module.exports = __webpack_public_path__ + "img/d2.2e2d1ef6.png";